import * as api from '@/api'
import * as http from '@/libs/http'
import { setTheme } from '@/libs/vuetify'

export default {
  /**
   * 組織情報をクリアする
   *
   * @param {Context} context
   */
  clear ({ commit, dispatch }) {
    // ステートを一式クリアする
    commit('setData', {})

    // 他のステートをクリアする
    dispatch('user/clear', null, { root: true })
  },

  /**
   * 組織コードから組織情報を設定する
   *
   * @param {Context} context
   * @param {String} orgcode 組織コード
   * @returns {Promise<Boolean>} 正常に組織情報を設定できたら true.
   */
  async setOrgCode ({ state, commit, dispatch }, orgcode) {
    if (state.code === orgcode) {
      return true
    }

    // API で組織情報を取得する
    const resp = await api.getOrg(orgcode, [
      'name',
      'traits',
      'agreements',
      'masters',
      'theme'
    ])
    if (resp.status === http.NotFound) {
      return false
    }

    // アプリケーションテーマを設定する
    const theme = resp.data.theme
    if (theme) {
      setTheme(theme)
    }

    // ステートを一式設定する
    commit('setData', resp.data)

    // 他のステートをクリアする
    dispatch('user/clear', null, { root: true })

    return true
  }
}
